import React from 'react';

import { Icon } from '@rbilabs/components-library';

import theme from './theme';

export const CloseIcon = () => (
  <Icon icon="close" color={theme.iconContainer.color} width="1.7rem" />
);
export const ArrowRightIcon = () => (
  <Icon icon="arrowRight" color={theme.iconContainer.color} width="0.4rem" />
);
